<template>
  <div
    class="chart-legend uppercase"
    data-tst="chart_legend"
  >
    <div
      v-if="title"
      class="chart-legend_title mr-1"
    >
      {{ title }}
    </div>
    <div
      v-if="hasFullscreen"
      class="mdi csst mdi-fullscreen text-normal icon_btn pa-1"
      style="margin-top: 0.125rem"
      @click="$emit('goFullscreen')"
    >
      <div
        class="csst_content"
        style="bottom: -1.75rem; left: -0.5rem"
      >
        {{ $t('tooltips.fullscreen') }}
      </div>
    </div>

    <div
      v-show="zoomApplied"
      class="mdi csst mdi-magnify-minus-outline text-normal icon_btn pa-1"
      @click="$emit('resetZoom')"
    >
      <div
        class="csst_content text-nowrap"
        style="bottom: -1.75rem"
      >
        {{ $t('tooltips.zoom_out') }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ChartLegend',
  props: {
    hasFullscreen: { type: Boolean, default: true },
    zoomApplied: Boolean,
    title: { default: '' },
  },
  emits: ['goFullscreen', 'resetZoom'],
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.chart-legend {
  position: absolute;
  top: 2px;
  left: 36px;

  padding: 0 4px;
  z-index: var(--z-index-chart-legend);
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: '';
    width: 60%;
    z-index: -1;
    height: 4px;
    position: absolute;
    // background: var(--clr-);
    // background: red;
  }
  &_title {
    font-size: 0.8rem;
    color: var(--clr-grey-2);
  }
}
</style>
